<div class="blogs-container">
    <div class="blogs-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/file_red.png" alt="File Icon" class="file-icon">
            <span class="header-title">
            <span class="title-text">Articles ( <span class="title-count">{{ totalCount }}</span> )</span>

            </span>
        </div>

        <div class="header-right">
            <button class="add-article-btn" (click)="addNewArticle()">
                <img src="assets/images/icons/file_edit.png" alt="Add" class="add-icon">
                <span>Ajouter un article</span>
            </button>
        </div>
    </div>

    <div class="search-filter-row">
        <div class="search-container">
            <div class="search-input-group">
                <img src="assets/images/icons/input_search.png" alt="Search" class="search-icon">
                <input type="text" class="search-input" placeholder="Rechercher des articles..." [(ngModel)]="searchTerm" (input)="onSearch()">
            </div>
        </div>
        <div class="filter-group">
            <select class="filter-select" [(ngModel)]="selectedVisibility" (change)="onFilterChange()">
                <option value="all">Tous(Visibilité)</option>
                <option value="true">Public</option>
                <option value="false">Privé</option>
            </select>
        </div>

        <div class="filter-group">
            <select class="filter-select" [(ngModel)]="selectedSort" (change)="onSortChange()">
                <option value="" disabled>Trier par</option>
                <option value="createdAt,desc">Date (plus récent)</option>
                <option value="createdAt,asc">Date (plus ancien)</option>
                <option value="title,asc">Titre (A-Z)</option>
                <option value="title,desc">Titre (Z-A)</option>
            </select>
        </div>

        <button class="filter-btn" (click)="toggleFilterPopup()">
            <img src="assets/images/icons/filter.png" alt="Filter" class="filter-icon">
            <span>Filtrer</span>
        </button>
    </div>

    <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>Chargement des articles...</p>
    </div>

    <div *ngIf="!isLoading && blogs.length === 0" class="empty-state">
        <p>Aucun article trouvé</p>
        <button class="add-first-btn" (click)="addNewArticle()">
            Ajouter un article
        </button>
    </div>

    <div *ngIf="!isLoading && blogs.length > 0" class="blogs-grid">
        <app-admin-blog-card *ngFor="let blog of blogs" [blog]="blog" (blogUpdated)="onBlogUpdated()" (blogDeleted)="onBlogDeleted()">
        </app-admin-blog-card>
        @if(totalPages>1){
        <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (pageChange)="onPageChange($event)"></app-pagination>
        }
    </div>

</div>

<div class="filter-overlay" *ngIf="showFilterPopup" (click)="closeFilterPopup($event)">
    <div class="filter-popup">

        <div class="filter-header">
            <h3 class="filter-title">Filtrer</h3>
            <button class="close-button" (click)="toggleFilterPopup()">×</button>
        </div>

    </div>
</div>